import React, { useState, useEffect, useCallback } from "react";
import { Link, useHistory } from "react-router-dom";
import { ReactComponent as Logo } from "assets/logo.svg";
import Stepper from "components/layout/Stepper";
import {
    Body,
    ButtonContainer,
    Container,
    Content,
    HeaderContainer,
    Section,
    SideBanner,
    SuccessContainer
} from "./styles";
import { RiCheckboxCircleLine } from "react-icons/ri";
import { MdPlayArrow, MdArrowForward } from "react-icons/md";
import ContainedButton from "components/layout/form/containedButton";
import api from "services/api";
import Loading from "components/layout/loading";
import { IoMdCloseCircle } from "react-icons/io";



const AdesaoEmail = () => {

    const [emailLoading] = useState({
        title: "Validação de E-mail",
        subTitle: "",
        text: "Carregando..."
    });

    const [emailSuccess] = useState({
        title: "E-mail validado!",
        subTitle: "Agora você pode acessar seu portal e visualizar todas suas unidades em um único login.",
        text: "Seu e-mail foi validado com sucesso!"
    });

    const [emailExpiration] = useState({
        title: "E-mail expirado!",
        subTitle: "O seu e-mail de ativação expirou, para validar novamente basta você reenvia-lo novamente para ativar",
        text: "Não foi possível concluir seu cadastro, seu e-mail de ativação foi expirado, favor tente novamente"
    });

    const [loading, setLoading] = useState(false);

    const [emailState, setEmailState] = useState(emailLoading);

    const [errorState, setErrorState] = useState(null);



    const [steppers] = useState([
        "Seu documento",
        "Cadastre sua Residência ou Loja",
        "Medidor",
        "Dados de Cobrança",
        "Dados Pessoais",
        "Validar Cadastro",
        "Cadastro Concluído"
    ]);

    const requestValidationEmail = useCallback(async(token, userId) => {
        setLoading(true);
        const body = {
            token
        };

        try {
            await api.post(`/industrial/customer/v1/users/${userId}/validations`, body);
            setEmailState(emailSuccess);
        } catch (error) {
            setEmailState(emailExpiration);
            setErrorState(7);
        }
        setLoading(false);

    }, [setLoading, api, setEmailState, setErrorState]);

    useEffect(() => {
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const token = params.get("token");
        const userId = params.get("user-id");
        requestValidationEmail(token, userId);
    },[]);

    return (
        <Container>
            <SideBanner>
                <Link to="/">
                    <Logo aria-label="Logo da Ultragaz" />
                </Link>
                <Stepper activated={8} errorState={errorState} steppers={steppers} scrollToEnd={false}/>
            </SideBanner>
            <Content>
                <Body>
                    <Section>

                        <HeaderContainer>
                            <span><MdPlayArrow />&nbsp;&nbsp;Primeiro Acesso</span>
                            <h1>{emailState.title}</h1>
                            <h2>{emailState.subTitle}</h2>
                        </HeaderContainer>

                        <SuccessContainer errorState={errorState}>
                            {
                                !loading && (
                                    !errorState ?
                                    <RiCheckboxCircleLine size={60} /> :
                                    <IoMdCloseCircle size={60}/>
                                )
                            }
                            <p>
                                {emailState.text}
                            </p>
                        </SuccessContainer>

                        <ButtonContainer>
                            <Link to="/">
                                <ContainedButton
                                    color="#4EC937"
                                    TrailingIcon={() => <MdArrowForward size={20} />}
                                >
                                    Acesse o portal
                                </ContainedButton>
                            </Link>
                        </ButtonContainer>
                    </Section>
                </Body>
            </Content>
        {loading && <Loading />}
        </Container>
    );
}



export default AdesaoEmail;
